import { MODAL_ID_DEFAULT } from '../../constants/common'
import { MINIMIZED_MODAL_KEY } from '../Modal'

export const FLAT_ACTION_ARCHIVE_ITEM = 'archive_item'

export const FLAT_ACTION_RESTORE_ITEM = 'restore_item'

export const FLAT_ACTION_RESTORE_MASS = 'restore_mass'

export const FLAT_ACTION_ARCHIVE_MASS = 'archive_mass'

export const FLAT_ACTION_EMAIL_ITEM = 'mailing_item'

export const FLAT_ACTION_MASS_EMAIL_ALL_USERS = 'mass_mailing_all'

export const FLAT_ACTION_MASS_EMAIL_LANDLORDS = 'mass_mailing_landlords'

export const FLAT_ACTION_MASS_EMAIL_TENANTS = 'mass_mailing_tenants'

export const FLAT_TABLE_MASS_ACTION_NAMES = {
  [FLAT_ACTION_ARCHIVE_ITEM]: 'archive',
  [FLAT_ACTION_ARCHIVE_MASS]: 'archive',
  [FLAT_ACTION_RESTORE_ITEM]: 'restore',
  [FLAT_ACTION_RESTORE_MASS]: 'restore',
}

export const FLAT_TABLE_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
}
